
import axios from 'axios'

export default {
    loadHistory(callback) {
        axios.get(process.env.ASSET_BASE_PATH + 'api/museum_history.json')
        .then(response => {
          // console.log(response.data) // mockData
          // console.log(response.status) // 200
          callback(response.data);
        })
        
    }
}


// WEBPACK FOOTER //
// ./src/api/products.js